import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { listInHousePackages } from './-query/api';

/**
 * テナント専用パッケージ一覧のエントリポイント。
 * 先頭の有効なパッケージへ遷移する。
 */
export const Route = createFileRoute(
  '/_staff/it-operation-core/_root/in-house-packages/',
)({
  loader: () => listInHousePackages(),
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const packages = Route.useLoaderData();

  useEffect(() => {
    if (packages.length > 0) {
      navigate({
        to: '/it-operation-core/in-house-packages/$packageId',
        params: { packageId: packages[0].id },
      });
    }
  }, [packages, navigate]);

  return null;
}
